module.exports = __webpack_public_path__ + "dni-02-02.png?c49941b5a2620e453d36c157a1449b21";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dni-02-02.png
// module id = 636
// module chunks = 0 2 7 8 9 10 11 16